/* insights-filter.ts */

/* Constants */
import { Insights } from "src/shared/constants/common/Common";

import {
  FilterProps,
  TimePeriodProps,
} from "src/shared/interfaces/insights-filter/InsightsFilter";

export const transformToDefaultCohort = (
  cohort: string
): string => {
  return cohort === Insights.FULL_SAMPLE ? "" : cohort;
};

export const transformTimePeriod = (
  timePeriod: FilterProps<Partial<TimePeriodProps>>
): TimePeriodProps => {
  const { firstYear = "2013", lastYear = "2024" } =
    timePeriod?.value || {};
  const {
    firstYear: initFirst = "2013",
    lastYear: initLast = "2024",
  } = timePeriod?.initialValue || {};

  return {
    firstYear: formatDate(firstYear || initFirst, "start"),
    lastYear: formatDate(lastYear || initLast, "end"),
  };
};

const formatDate = (
  year: string | undefined,
  type: "start" | "end"
): string => {
  const cleanedYear = year?.trim() || "";
  const finalYear =
    cleanedYear !== "" ? cleanedYear : undefined;
  return `${finalYear ?? "0000"}-${
    type === "start" ? "01-01" : "12-31"
  }`;
};
